import { createSlice } from "@reduxjs/toolkit";

export const hookCity = createSlice({
	name: "hookCity",
	initialState: {
		cityId: 2,
		cityName: "South Delhi",
	},
	reducers: {
		updateHookCity: (state, action) => {
			return action.payload || state;
		},
	},
});

// Action creators are generated for each case reducer function
export const { updateHookCity } = hookCity.actions;

export const HookCityReducer = hookCity.reducer;
